import mapKnownValues from "../utils/mapKnownValues";
import DestinationAccount, { DestinationAccountResponse } from "./destinationAccount";
import SourceAccount, { SourceAccountResponse } from "./sourceAccount";

export const STEP_CONSENT = "STEP_CONSENT";
export const STEP_TRANSFER_INFO = "STEP_TRANSFER_INFO";

export const STEP_OLD_ACCOUNT_SPONSOR_NAME = "STEP_OLD_ACCOUNT_SPONSOR_NAME";
export const STEP_OLD_ACCOUNT_HAS_ACCOUNT_STATEMENT = "STEP_OLD_ACCOUNT_HAS_ACCOUNT_STATEMENT";
export const STEP_OLD_ACCOUNT_UPLOAD_STATEMENT = "STEP_OLD_ACCOUNT_UPLOAD_STATEMENT";
export const STEP_OLD_ACCOUNT_UPLOAD_STATEMENT_SUCCEED = "STEP_OLD_ACCOUNT_UPLOAD_STATEMENT_SUCCEED";
export const STEP_OLD_ACCOUNT_EMPLOYMENT_DETAILS = "STEP_OLD_ACCOUNT_EMPLOYMENT_DETAILS";
export const STEP_OLD_ACCOUNT_PROVIDER_SEARCH = "STEP_OLD_ACCOUNT_PROVIDER_SEARCH";
export const STEP_OLD_ACCOUNT_PROVIDER_KNOWN_SCREEN = "STEP_OLD_ACCOUNT_PROVIDER_KNOWN_SCREEN";
export const STEP_OLD_ACCOUNT_HAS_ANOTHER_ACCOUNT = "STEP_OLD_ACCOUNT_HAS_ANOTHER_ACCOUNT";
export const STEP_OLD_ACCOUNT_COMPLETED_HOME = "STEP_OLD_ACCOUNT_COMPLETED_HOME";
export const STEP_OLD_ACCOUNT_FLASH_LOADING = "STEP_OLD_ACCOUNT_FLASH_LOADING";
export const STEP_OLD_ACCOUNT_CONFIRM = "STEP_OLD_ACCOUNT_CONFIRM";
export const STEP_DESTINATION_FLASH_LOADING_TRANFER_IN = "STEP_DESTINATION_FLASH_LOADING_TRANFER_IN";
export const STEP_DESTINATION_IRA_FOUND = "STEP_DESTINATION_IRA_FOUND";
export const STEP_DESTINATION_OPTIONS = "STEP_DESTINATION_OPTIONS";
export const STEP_DESTINATION_OPTIONS_TYPE = "STEP_DESTINATION_OPTIONS_TYPE";
export const STEP_DESTINATION_ACCOUNT = "STEP_DESTINATION_ACCOUNT";
export const STEP_DESTINATION_OPEN_AND_CONNECT_IRA = "STEP_DESTINATION_OPEN_AND_CONNECT_IRA";
export const STEP_DESTINATION_CONNECT_IRA = "STEP_DESTINATION_CONNECT_IRA";
export const STEP_DESTINATION_CONNECT_IRA_TYPE = "STEP_DESTINATION_CONNECT_IRA_TYPE";
export const STEP_DESTINATION_CONNECT_ES = "STEP_DESTINATION_CONNECT_ES";
export const STEP_DESTINATION_CONNECT_ES_UPLOAD_STATEMENT = "STEP_DESTINATION_CONNECT_ES_UPLOAD_STATEMENT";
export const STEP_DESTINATION_CONNECT_ES_DETAILS = "STEP_DESTINATION_CONNECT_ES_DETAILS";
export const STEP_DESTINATION_METHODOLOGY_SCREEN = "STEP_DESTINATION_METHODOLOGY_SCREEN";

export const STEP_DESTINATION_HELP = "STEP_DESTINATION_HELP";
export const STEP_DESTINATION_HELP_1 = "STEP_DESTINATION_HELP_1";
export const STEP_DESTINATION_HELP_2 = "STEP_DESTINATION_HELP_2";
export const STEP_DESTINATION_HELP_3 = "STEP_DESTINATION_HELP_3";
export const STEP_DESTINATION_HELP_4 = "STEP_DESTINATION_HELP_4";
export const STEP_DESTINATION_HELP_5 = "STEP_DESTINATION_HELP_5";
export const STEP_DESTINATION_HELP_6A = "STEP_DESTINATION_HELP_6A";
export const STEP_DESTINATION_HELP_6B = "STEP_DESTINATION_HELP_6B";
export const STEP_DESTINATION_HELP_6C = "STEP_DESTINATION_HELP_6C";
export const STEP_DESTINATION_HELP_RESULT_LOADING = "STEP_DESTINATION_HELP_RESULT_LOADING";
export const STEP_DESTINATION_HELP_RESULT = "STEP_DESTINATION_HELP_RESULT";
// EXPLORE IRA
export const STEP_DESTINATION_EXPLORE_IRA = "STEP_DESTINATION_EXPLORE_IRA";
export const STEP_DESTINATION_EXPLORE_IRA_1 = "STEP_DESTINATION_EXPLORE_IRA_1";
export const STEP_DESTINATION_EXPLORE_IRA_2 = "STEP_DESTINATION_EXPLORE_IRA_2";
export const STEP_DESTINATION_EXPLORE_IRA_3 = "STEP_DESTINATION_EXPLORE_IRA_3";
export const STEP_DESTINATION_EXPLORE_IRA_LOADING = "STEP_DESTINATION_EXPLORE_IRA_LOADING";
export const STEP_DESTINATION_EXPLORE_IRA_RESULT = "STEP_DESTINATION_EXPLORE_IRA_RESULT";
export const STEP_DESTINATION_IRA_METHODOLOGY_SCREEN = "STEP_DESTINATION_IRA_METHODOLOGY_SCREEN";

// IRA PARTNER
export const STEP_DESTINATION_EXPLORE_IRA_OPTIONS = "STEP_DESTINATION_EXPLORE_IRA_OPTIONS";
export const STEP_DESTINATION_EXPLORE_IRA_OPTION_FUTUREMONEY = "STEP_DESTINATION_EXPLORE_IRA_OPTION_FUTUREMONEY";
export const STEP_DESTINATION_EXPLORE_IRA_OPTION_BETTERMENT = "STEP_DESTINATION_EXPLORE_IRA_OPTION_BETTERMENT";
export const STEP_DESTINATION_EXPLORE_IRA_OPTION_ROBINHOOD = "STEP_DESTINATION_EXPLORE_IRA_OPTION_ROBINHOOD";
export const STEP_DESTINATION_EXPLORE_IRA_OPTION_SOFI = "STEP_DESTINATION_EXPLORE_IRA_OPTION_SOFI";

export const STEP_PERSONAL_INFO = "STEP_PERSONAL_INFO";
export const STEP_MARTIAL_INFO = "STEP_MARTIAL_INFO";
export const STEP_MAILING_ADDRESS = "STEP_MAILING_ADDRESS";
export const STEP_IRA_OPEN_FORM = "STEP_IRA_OPEN_FORM";
export const STEP_INITIATE_TRANSFER = "STEP_INITIATE_TRANSFER";
export const STEP_POST_TRANSFER = "STEP_POST_TRANSFER";
export const STEP_SCHEDULE_PHONE_CALL = "STEP_SCHEDULE_PHONE_CALL";
export const STEP_SCHEDULE_PHONE_CALL_NO_LOADING = "STEP_SCHEDULE_PHONE_CALL_NO_LOADING";
export const STEP_SCHEDULE_PHONE_CALL_CONFIRMATION = "STEP_SCHEDULE_PHONE_CALL_CONFIRMATION";
export const STEP_OPEN_IRA = "STEP_OPEN_IRA";
export const STEP_IRA_EXIT_SCREEN = "STEP_IRA_EXIT_SCREEN";
export const STEP_CONFIRM_TRANSFER_DETAILS = "STEP_CONFIRM_TRANSFER_DETAILS";

export type SourceAccountStep =
  | typeof STEP_OLD_ACCOUNT_SPONSOR_NAME
  | typeof STEP_OLD_ACCOUNT_HAS_ACCOUNT_STATEMENT
  | typeof STEP_OLD_ACCOUNT_UPLOAD_STATEMENT
  | typeof STEP_OLD_ACCOUNT_UPLOAD_STATEMENT_SUCCEED
  | typeof STEP_OLD_ACCOUNT_EMPLOYMENT_DETAILS
  | typeof STEP_OLD_ACCOUNT_PROVIDER_SEARCH
  | typeof STEP_OLD_ACCOUNT_PROVIDER_KNOWN_SCREEN
  | typeof STEP_OLD_ACCOUNT_HAS_ANOTHER_ACCOUNT
  | typeof STEP_OLD_ACCOUNT_COMPLETED_HOME
  | typeof STEP_OLD_ACCOUNT_FLASH_LOADING
  | typeof STEP_OLD_ACCOUNT_CONFIRM;

export type DestinationStep =
  | typeof STEP_DESTINATION_FLASH_LOADING_TRANFER_IN
  | typeof STEP_DESTINATION_IRA_FOUND
  | typeof STEP_DESTINATION_OPTIONS
  | typeof STEP_DESTINATION_OPTIONS_TYPE
  | typeof STEP_DESTINATION_ACCOUNT
  | typeof STEP_DESTINATION_CONNECT_IRA
  | typeof STEP_DESTINATION_CONNECT_IRA_TYPE
  | typeof STEP_DESTINATION_CONNECT_ES
  | typeof STEP_DESTINATION_CONNECT_ES_UPLOAD_STATEMENT
  | typeof STEP_DESTINATION_CONNECT_ES_DETAILS
  | typeof STEP_DESTINATION_HELP
  | typeof STEP_DESTINATION_HELP_RESULT
  | typeof STEP_DESTINATION_HELP_1
  | typeof STEP_DESTINATION_HELP_2
  | typeof STEP_DESTINATION_HELP_3
  | typeof STEP_DESTINATION_HELP_4
  | typeof STEP_DESTINATION_HELP_5
  | typeof STEP_DESTINATION_HELP_6A
  | typeof STEP_DESTINATION_HELP_6B
  | typeof STEP_DESTINATION_HELP_6C
  | typeof STEP_DESTINATION_HELP_RESULT_LOADING
  | typeof STEP_DESTINATION_OPEN_AND_CONNECT_IRA
  | typeof STEP_DESTINATION_METHODOLOGY_SCREEN;

export type IRAScreenType =
  | typeof STEP_DESTINATION_EXPLORE_IRA
  | typeof STEP_DESTINATION_EXPLORE_IRA_1
  | typeof STEP_DESTINATION_EXPLORE_IRA_2
  | typeof STEP_DESTINATION_EXPLORE_IRA_3
  | typeof STEP_DESTINATION_EXPLORE_IRA_LOADING
  | typeof STEP_DESTINATION_EXPLORE_IRA_RESULT
  | typeof STEP_DESTINATION_EXPLORE_IRA_OPTIONS
  | typeof STEP_DESTINATION_EXPLORE_IRA_OPTION_FUTUREMONEY
  | typeof STEP_DESTINATION_EXPLORE_IRA_OPTION_BETTERMENT
  | typeof STEP_DESTINATION_EXPLORE_IRA_OPTION_ROBINHOOD
  | typeof STEP_DESTINATION_EXPLORE_IRA_OPTION_SOFI
  | typeof STEP_DESTINATION_IRA_METHODOLOGY_SCREEN;

export type TransferStep =
  | typeof STEP_CONSENT
  | typeof STEP_TRANSFER_INFO
  | typeof STEP_OLD_ACCOUNT_SPONSOR_NAME
  | typeof STEP_OLD_ACCOUNT_HAS_ACCOUNT_STATEMENT
  | typeof STEP_OLD_ACCOUNT_UPLOAD_STATEMENT
  | typeof STEP_OLD_ACCOUNT_UPLOAD_STATEMENT_SUCCEED
  | typeof STEP_OLD_ACCOUNT_EMPLOYMENT_DETAILS
  | typeof STEP_OLD_ACCOUNT_PROVIDER_SEARCH
  | typeof STEP_OLD_ACCOUNT_PROVIDER_KNOWN_SCREEN
  | typeof STEP_OLD_ACCOUNT_HAS_ANOTHER_ACCOUNT
  | typeof STEP_OLD_ACCOUNT_COMPLETED_HOME
  | typeof STEP_OLD_ACCOUNT_CONFIRM
  | typeof STEP_OLD_ACCOUNT_FLASH_LOADING
  | typeof STEP_DESTINATION_ACCOUNT
  | typeof STEP_CONFIRM_TRANSFER_DETAILS
  | typeof STEP_PERSONAL_INFO
  | typeof STEP_MARTIAL_INFO
  | typeof STEP_MAILING_ADDRESS
  | typeof STEP_IRA_OPEN_FORM
  | typeof STEP_INITIATE_TRANSFER
  | typeof STEP_POST_TRANSFER
  | typeof STEP_SCHEDULE_PHONE_CALL
  | typeof STEP_SCHEDULE_PHONE_CALL_NO_LOADING
  | typeof STEP_SCHEDULE_PHONE_CALL_CONFIRMATION
  | typeof STEP_OPEN_IRA
  | typeof STEP_IRA_EXIT_SCREEN
  | DestinationStep
  | IRAScreenType;

export enum TransferStatusTypes {
  none = "",
  cancelled = "CANCELLED",
  complete = "COMPLETE",
  inProgress = "INPROGRESS",
  initiatedAtProvider = "INITIATED_AT_PROVIDER",
  mailProcess = "MAIL_PROCESS",
  processing = "PROCESSING",
  userInputNeeded = "USER_INPUT_NEEDED",
  inQueue = "WAIT_FOR_OPERATIONS",
  initiated = "INITIATED",
  funds = "FUNDS", // for testing purpose
}

// class object from API
export type TransferResponse = {
  destinationAccount: DestinationAccountResponse | null;
  sourceAccounts: SourceAccountResponse[] | null;
  transferId: number;
  transferStatus: TransferStatusTypes;
  userIdentityId: number;
  transferIntentReference: string;
  userId: string;
};

class TransferDetails {
  transferId = -1;
  sourceAccounts: SourceAccount[] = [];
  destinationAccount: DestinationAccount | null = null;
  transferStatus: TransferStatusTypes = TransferStatusTypes.none;

  constructor(params: Partial<TransferDetails> = {}) {
    mapKnownValues(this, params);
  }
  get currentStep() {
    if (this.sourceAccounts.length === 0) {
      return STEP_OLD_ACCOUNT_SPONSOR_NAME;
    }
    if (this.sourceAccounts.length > 0) {
      const hasIncompleteSourceAccount = this.sourceAccounts.filter((s) => !s.isCompleted)[0];
      if (hasIncompleteSourceAccount) {
        return hasIncompleteSourceAccount.currentStep;
      }
    }
    if (this.sourceAccounts.length > 0 && this.destinationAccount === null) {
      return STEP_OLD_ACCOUNT_HAS_ANOTHER_ACCOUNT;
    }
    if (this.sourceAccounts.length > 0 && this.destinationAccount !== null) {
      return STEP_CONFIRM_TRANSFER_DETAILS;
    }

    return STEP_OLD_ACCOUNT_SPONSOR_NAME;
  }

  static fromAPI(response: TransferResponse | undefined) {
    let transferSources: SourceAccount[] = [];
    if (!response) {
      return new TransferDetails();
    }
    if (response.sourceAccounts) {
      transferSources = response.sourceAccounts.map((source) => SourceAccount.fromApi(source));
    }
    return new TransferDetails({
      ...response,
      destinationAccount: response.destinationAccount ? DestinationAccount.fromApi(response.destinationAccount) : null,
      sourceAccounts: transferSources,
    });
  }
}

export default TransferDetails;
